import { useIntl } from "react-intl";
import { FaSyringe } from "react-icons/fa";
import { BsFileEarmarkTextFill } from "react-icons/bs";

import { AsideMenuItem } from "./AsideMenuItem";

export function AsideMenuMain() {
	const intl = useIntl();

	return (
		<>
			{/* cirurgical center */}
			<AsideMenuItem
				to="/centro-cirurgico"
				icon={<FaSyringe />}
				title={intl.formatMessage({ id: "DEPARTMENTS.CIRURGICAL_CENTER.TITLE" })}
			/>

			<AsideMenuItem
				to="/gerenciamento-aih"
				icon={<BsFileEarmarkTextFill />}
				title="Gerenciamento de AIH"
			/>
		</>
	);
}
